module.exports = __webpack_public_path__ + "static/img/chenweiqi.b643d67.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/trusteeCouncil/images/chenweiqi.png
// module id = jAcJ
// module chunks = 0